var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.42857C7 4.04969 7.1475 3.68633 7.41005 3.41842C7.6726 3.15051 8.0287 3 8.4 3H12.6C12.9713 3 13.3274 3.15051 13.5899 3.41842C13.8525 3.68633 14 4.04969 14 4.42857V11.5714C14 11.9503 13.8525 12.3137 13.5899 12.5816C13.3274 12.8495 12.9713 13 12.6 13H8.4C8.0287 13 7.6726 12.8495 7.41005 12.5816C7.1475 12.3137 7 11.9503 7 11.5714V4.42857Z",
    stroke: "#FFD47E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4V12",
    stroke: "#FFD47E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5V10",
    stroke: "#FFD47E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.f3763fcd349a98a3a03fb397dfba12fd.svg";
export { ForwardRef as ReactComponent };